import { ParticipantType, Participants, Subject, Test } from 'features/monitoring/models';
import { useMemo } from 'react';
import { getChartData } from 'features/monitoring/charts/getChartData';

export const useChartsProps = (participants: Participants | undefined, tests: Test[], subject: Subject) => {
  return useMemo(() => {
    if (!participants || !tests) {
      return null;
    }

    const studentSamples = getChartData(tests, participants.total, subject, ParticipantType.Student);
    const teacherSamples = getChartData(tests, participants.total, subject, ParticipantType.Teacher);

    return {
      studentSamples,
      teacherSamples,
    };
  }, [tests, participants, subject]);
};
